import { Reveal } from "@/components/Reveal";

const G = [
  ["Handover & discovery", 1, 1],
  ["Data model & mapping", 1, 2],
  ["Monthly Budget + import", 2, 5],
  ["Forecast engine", 3, 7],
  ["Pacing roll-up", 5, 8],
  ["Reports & dashboards", 6, 10],
  ["Testing, UAT, handoff", 8, 11],
];

const WEEKS = Array.from({ length: 12 }, (_, i) => i + 1);

export default function Timeline() {
  return (
    <section id="timeline" className="mx-auto max-w-6xl px-4 sm:px-6 mt-14 scroll-mt-16" data-testid="section-timeline">
      <Reveal>
        <p className="font-mono text-[11.5px] uppercase tracking-[0.08em] text-fog">Timeline</p>
        <h2 className="mt-2 font-display text-2xl sm:text-3xl text-coal">
          Budget vs Booked by week 8, go-live within 12 weeks
        </h2>
        <p className="mt-2 text-[15px] text-fog max-w-3xl">
          We plan to 10 weeks and keep 2 as buffer. With an early November kickoff, weeks
          7-9 fall over Christmas and New Year, when UAT usually slows down, so we expect
          to use some of it.
        </p>
      </Reveal>

      <Reveal delay={0.05}>
        <div className="mt-5 bg-white border border-hair rounded-md p-5 overflow-x-auto" data-testid="timeline-gantt">
          <div className="grid gap-1.5 min-w-[680px]">
            <div className="grid grid-cols-[190px_1fr] gap-2.5">
              <span />
              <div className="grid grid-cols-12 font-mono text-[11px] text-fog text-center">
                {WEEKS.map((w) => (
                  <span key={w}>Wk {w}</span>
                ))}
              </div>
            </div>
            {G.map(([name, s, e], i) => (
              <div key={name} className="grid grid-cols-[190px_1fr] gap-2.5 items-center text-[13px]">
                <span className="text-coal/85">{name}</span>
                <div
                  className="relative h-[22px] grid grid-cols-12"
                  style={{ background: "repeating-linear-gradient(90deg, transparent 0, transparent calc(8.333% - 1px), #D6DBDF calc(8.333% - 1px), #D6DBDF 8.333%)" }}
                >
                  <span
                    className="absolute top-1 h-[14px] rounded-full bg-sunk border-[1.25px] border-coal"
                    style={{ left: `calc(${((s - 1) / 12) * 100}% + 2px)`, width: `calc(${((e - s + 1) / 12) * 100}% - 4px)` }}
                    data-testid={`timeline-bar-${i + 1}`}
                  />
                </div>
              </div>
            ))}
            <div className="grid grid-cols-[190px_1fr] gap-2.5 items-center text-[13px]">
              <span className="text-coal/85">Christmas &amp; New Year</span>
              <div className="relative h-[22px]">
                <span
                  className="absolute top-1 h-[14px] rounded-[2px] border border-dashed border-fog bg-sunk"
                  style={{ left: "calc(50% + 2px)", width: "calc(25% - 4px)" }}
                  data-testid="timeline-holidays"
                />
              </div>
            </div>
            <div className="grid grid-cols-[190px_1fr] gap-2.5 items-center text-[13px]">
              <b className="text-coal">Foundation complete (30%)</b>
              <div className="relative h-[22px]">
                <span className="absolute top-[4px] w-3.5 h-3.5 rotate-45 bg-coal" style={{ left: "calc(33.333% - 7px)" }} data-testid="timeline-milestone-foundation" />
              </div>
            </div>
            <div className="grid grid-cols-[190px_1fr] gap-2.5 items-center text-[13px]">
              <b className="text-coal">Budget vs Booked live</b>
              <div className="relative h-[22px]">
                <span className="absolute top-[4px] w-3.5 h-3.5 rotate-45 bg-coal" style={{ left: "calc(66.667% - 7px)" }} data-testid="timeline-milestone-week-8" />
              </div>
            </div>
            <div className="grid grid-cols-[190px_1fr] gap-2.5 items-center text-[13px]">
              <span className="text-coal/85">Go-live (20%)</span>
              <div className="relative h-[22px]">
                <span className="absolute top-[4px] w-3.5 h-3.5 rotate-45 bg-fog" style={{ left: "calc(100% - 7px)" }} data-testid="timeline-milestone-week-12" />
              </div>
            </div>
            <div className="grid grid-cols-[190px_1fr] gap-2.5 items-center text-[13px]">
              <b className="text-coal">Buffer</b>
              <div className="relative h-[22px]">
                <span
                  className="absolute top-1 h-[14px] rounded-full border border-dashed border-fog"
                  style={{ left: "calc(83.333% + 2px)", width: "calc(16.667% - 4px)" }}
                  data-testid="timeline-bar-buffer"
                />
              </div>
            </div>
          </div>
        </div>
      </Reveal>

      <div className="mt-4 grid md:grid-cols-2 gap-3" data-testid="timeline-phase-cards">
        {[
          ["Weeks 1-8", "Budget vs Booked", "Sandbox test and foundation by week 4, then the Monthly Budget import, billing code alignment and the first dashboards."],
          ["Weeks 9-12", "Weighted forecast and handoff", "Forecast records live, full dashboards, reconciliation against WideOrbit, UAT, training and documentation. Weeks 11-12 are buffer."],
        ].map(([w, t, b], i) => (
          <Reveal key={w} delay={i * 0.05}>
            <div className="bg-white border border-hair rounded-md p-4 h-full">
              <p className="font-mono text-[12px] text-fog">{w}</p>
              <p className="mt-1.5 font-display text-lg text-coal">{t}</p>
              <p className="mt-2 text-[14px] text-fog leading-relaxed">{b}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.08}>
        <p className="mt-4 text-[13px] text-fog leading-relaxed">
          On projects like this, the pace is set by decisions and UAT turnaround more than
          by the build itself. The timeline assumes the week 1 decisions are closed and
          the templates come back by week 3.
        </p>
      </Reveal>
    </section>
  );
}
